import { ModeloCobrancaContrato } from '@core/models/models';

const MODELO_COBRANCA_API: Record<string, ModeloCobrancaContrato> = {
  fixo_mensal: 1,
  por_efetivo: 2,
  por_posto: 3,
  por_hora: 4,
};

const MODELO_COBRANCA_DESCRICAO: Record<string, string> = {
  fixo_mensal: 'Fixo Mensal',
  por_efetivo: 'Por Efectivo',
  por_posto: 'Por Posto',
  por_hora: 'Por Hora',
};

const MODELO_COBRANCA_UI: Record<ModeloCobrancaContrato, string> = {
  1: 'fixo_mensal',
  2: 'por_efetivo',
  3: 'por_posto',
  4: 'por_hora',
};

export interface ContratoCobrancaEntrada {
  modelo: string;
  valorMensal?: number | null;
  valorUnitario?: number | null;
  numEfetivos?: number | null;
  numPostos?: number | null;
  numHoras?: number | null;
}

export interface ContratoCobrancaResumo {
  modeloCobranca: ModeloCobrancaContrato;
  descricaoFaturacao: string;
  valorMensal: number;
  valorUnitario: number;
  quantidade: number;
}

export function getModeloCobrancaUi(
  modelo?: ModeloCobrancaContrato | null,
): string {
  return modelo ? (MODELO_COBRANCA_UI[modelo] ?? 'fixo_mensal') : 'fixo_mensal';
}

export function calcularCobrancaContrato(
  entrada: ContratoCobrancaEntrada,
): ContratoCobrancaResumo {
  const modelo = MODELO_COBRANCA_API[entrada.modelo]
    ? entrada.modelo
    : 'fixo_mensal';
  const modeloCobranca = MODELO_COBRANCA_API[modelo];
  const descricaoFaturacao = MODELO_COBRANCA_DESCRICAO[modelo];

  if (modelo === 'fixo_mensal') {
    const valorMensal = Number(entrada.valorMensal) || 0;
    return {
      modeloCobranca,
      descricaoFaturacao,
      valorMensal,
      valorUnitario: valorMensal,
      quantidade: 1,
    };
  }

  const valorUnitario = Number(entrada.valorUnitario) || 0;
  const quantidade =
    modelo === 'por_efetivo'
      ? Number(entrada.numEfetivos) || 0
      : modelo === 'por_posto'
        ? Number(entrada.numPostos) || 0
        : Number(entrada.numHoras) || 0;

  return {
    modeloCobranca,
    descricaoFaturacao,
    valorMensal: valorUnitario * quantidade,
    valorUnitario,
    quantidade,
  };
}
